import { clearAppStorage } from 'src/common/storage';
import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router';
import { setGlobalState, useGlobalState } from 'src/state/globalstate';
import { captureLogout } from 'src/common/analytics';

function IdleTimer() {
  let navigate = useNavigate();
  const [loggedin] = useGlobalState('loggedin');

  // Set timeout values
  const timeout = 1000 * 60 * 30;

  const promptTimeout = 100;
  const crosstab = false;

  // Modal open state
  const [open, setOpen] = useState(false);

  // Time before idle
  const [remaining, setRemaining] = useState(0);

  const onPrompt = () => {
    // onPrompt will be called after the timeout value is reached
    // In this case 30 minutes. Here you can open your prompt.
    // All events are disabled while the prompt is active.
    // If the user wishes to stay active, call the `reset()` method.
    // You can get the remaining prompt time with the `getRemainingTime()` method,
    setOpen(true);
    setRemaining(promptTimeout);
  };

  const performLogout = () => {
    const URL = window.location.href;
    // //console.log(URL);
    // Never clear the session from an auth page or when there's no active
    // session. localStorage is shared across tabs, so a backgrounded /login
    // (or register/forget) tab going idle must NOT wipe the token an active
    // work tab is using.
    const path = window.location.pathname.toLowerCase();
    const onAuthPage =
      path.includes('login') ||
      path.includes('register') ||
      path.includes('forget') ||
      path.includes('awsauth') ||
      path.includes('demo-');
    if (onAuthPage || !localStorage.getItem('token')) {
      setOpen(false);
      setRemaining(0);
      return;
    }
    if (
      URL.includes('dashboards/casetest/') ||
      URL.includes('dashboards/case/')
    ) {
      // //console.log('Hude Document Uploading');
    } else {
      captureLogout('idle_timeout');
      const selectedLanguage = localStorage.getItem('language');
      const languageType = localStorage.getItem('languageType');
      clearAppStorage();
      localStorage.setItem('language', selectedLanguage);
      localStorage.setItem('languageType', languageType);
      navigate('/login');
      setGlobalState('loggedin', false);
      setOpen(false);
      setRemaining(0);
    }
  };

  const onIdle = () => {
    performLogout();
  };

  const onActive = () => {
    // onActive will only be called if `reset()` is called while `isPrompted()`
    // is true. Here you will also want to close your modal and perform
    // any active actions.
    setOpen(false);
    setRemaining(0);
  };

  const onAction = () => {
    // onActive will only be called if `reset()` is called while `isPrompted()`
    // is true. Here you will also want to close your modal and perform
    // any active actions.
    const time = Date.now();
    localStorage.setItem('Expiretime', String(time));
    setOpen(false);
    setRemaining(0);
  };

  const { getRemainingTime, isPrompted, reset } = useIdleTimer({
    timeout,
    crossTab: true,
    promptTimeout,
    onPrompt,
    onIdle,
    onActive,
    onAction
  });

  const handleStillHere = () => {
    setOpen(false);
    reset();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (isPrompted()) {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime, isPrompted]);

  // Wall-clock inactivity guard.
  //
  // react-idle-timer counts down with setTimeout, which browsers throttle or
  // pause while the tab is backgrounded or the machine is asleep. So when a
  // user walks away for >30 min, onIdle does NOT fire on schedule — it only
  // catches up once they return and interact, which is why the logout used to
  // wait for a click instead of happening immediately. We compare the real
  // elapsed time since the last activity (`Expiretime`, stamped in onAction)
  // against the timeout on every return-to-tab and on a short interval, so an
  // expired session is torn down the instant the user comes back.
  useEffect(() => {
    // Seed the stamp so the check works before the first user action fires
    // onAction (e.g. immediately after login or a page reload).
    if (!localStorage.getItem('Expiretime')) {
      localStorage.setItem('Expiretime', String(Date.now()));
    }

    const checkExpiry = () => {
      const path = window.location.pathname.toLowerCase();
      const onAuthPage =
        path.includes('login') ||
        path.includes('register') ||
        path.includes('forget') ||
        path.includes('awsauth') ||
        path.includes('demo-');
      // Not an active session (auth page or no token) — keep the stamp fresh so
      // logging in always starts a full 30-min window, never inheriting a stale
      // timestamp from before the session.
      if (onAuthPage || !localStorage.getItem('token')) {
        localStorage.setItem('Expiretime', String(Date.now()));
        return;
      }
      const last = Number(localStorage.getItem('Expiretime'));
      if (!last) {
        localStorage.setItem('Expiretime', String(Date.now()));
        return;
      }
      if (Date.now() - last >= timeout) {
        performLogout();
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === 'visible') checkExpiry();
    };

    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', checkExpiry);
    const wallClock = setInterval(checkExpiry, 15000);
    // Run once on mount too — covers a full reload after a long absence.
    checkExpiry();

    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', checkExpiry);
      clearInterval(wallClock);
    };
  }, []);

  return (
    <>
      <div> </div>
    </>
  );
}

export default IdleTimer;
